import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { KnowledgeBaseFindInterface } from '@zaoblako/shared/modules/ai/dtos/knowledge-base/knowledge-base-find.dto';
import type { KnowledgeBaseItemsPageInterface } from '@zaoblako/shared/modules/ai/dtos/knowledge-base/knowledge-base-items-page.dto';
import type { KnowledgeBasePageInterface } from '@zaoblako/shared/modules/ai/dtos/knowledge-base/knowledge-base-page.dto';
import type { KnowledgeBaseQueryInterface } from '@zaoblako/shared/modules/ai/dtos/knowledge-base/knowledge-base-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiKnowledgeBaseService extends BaseService {
  protected baseUrl = '/ai/knowledge-base';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: KnowledgeBaseQueryInterface): Observable<KnowledgeBaseItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<KnowledgeBaseItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findWithPagination(queryParams: KnowledgeBaseQueryInterface): Observable<KnowledgeBasePageInterface> {
    return this.http.get<KnowledgeBasePageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<KnowledgeBaseFindInterface> {
    return this.http.post<KnowledgeBaseFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public updateEmbeddings(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/update-embeddings`, null);
  }
}
